import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { Client } from "../client.model";
import { ClientContactPerson } from "./client-contact-person.model";
import { ClientContactPersonMapper } from "./client-contact-person.mapper";

@Injectable()
export class ClientContactPersonRepository {
  protected http = inject(HttpClient);

  public list(client: Client): Observable<ClientContactPerson[]> {
    return this.http
      .get<any>(
        `${environment.apiUrl}/client/${client.getId()}/contactPerson`,
        {},
      )
      .pipe(map((response) => response.map(ClientContactPersonMapper.map)));
  }

  public add(model: ClientContactPerson): Observable<ClientContactPerson> {
    return this.http
      .post<ClientContactPerson>(
        `${environment.apiUrl}/client/${model
          .getClient()
          .getId()}/contactPerson`,
        model.getRequestParams(),
      )
      .pipe(map((response) => ClientContactPersonMapper.map(response)));
  }

  public save(model: ClientContactPerson): Observable<ClientContactPerson> {
    return this.http.patch<ClientContactPerson>(
      `${environment.apiUrl}/contactPerson/${model.getId()}`,
      model.getRequestParams(),
    );
  }

  public delete(model: ClientContactPerson): Observable<object> {
    return this.http.delete(
      `${environment.apiUrl}/contactPerson/${model.getId()}`,
    );
  }
}
